import { render, staticRenderFns } from "./BaseMarkdownEditor.vue?vue&type=template&id=398ba833&scoped=true"
import script from "./BaseMarkdownEditor.vue?vue&type=script&lang=js"
export * from "./BaseMarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseMarkdownEditor.vue?vue&type=style&index=0&id=398ba833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ba833",
  null
  
)

export default component.exports